export default {
    /* GET_ORDERS
    ---------------------------------------------------------------
    */
    GET_ORDERS_REQUEST: state => {
        state.ordersLoading = true
    },
    GET_ORDERS_SUCCESS: (state, data) => {
        state.orders = data.results
        state.ordersLoading = false
    },
    GET_ORDERS_FAILURE: state => {
        state.ordersLoading = false
    },

    GET_ORDERS_FOR_SHIPPING_LABELS_REQUEST: state => {
        state.ordersForShippingLabelsLoading = true
    },
    GET_ORDERS_FOR_SHIPPING_LABELS_SUCCESS: (state, data) => {
        state.ordersForShippingLabels = data.results
        state.ordersForShippingLabelsLoading = false
    },
    GET_ORDERS_FOR_SHIPPING_LABELS_FAILURE: state => {
        state.ordersForShippingLabelsLoading = false
    },
    SET_ORDER_STATUS_LIST: (state, data) => {
        state.orderStatusList = data.results
    },
    SET_ECOMMERCE_ORDERS_FILTERS: (state, filters) => {
        state.ecommerceOrdersFilters = filters
    },
    SET_INTERNAL_ORDERS_FILTERS: (state, filters) => {
        state.internalOrdersFilters = filters
    },
    SET_NONSTANDARD_ORDERS_FILTERS: (state, filters) => {
        state.nonStandardOrdersFilters = filters
    },
    CLEAR_ECOMMERCE_ORDERS_FILTERS: state => {
        state.ecommerceOrdersFilters = state.setInitialEcommerceOrdersFilters()
    },
    CLEAR_INTERNAL_ORDERS_FILTERS: state => {
        state.internalOrdersFilters = state.setInitialInternalOrdersFilters()
    },
    CLEAR_NONSTANDARD_ORDERS_FILTERS: state => {
        state.nonStandardOrdersFilters = state.setInitialNonStandardOrdersFilters()
    }
}